import React, { useState, useEffect } from 'react';
import ComponentSubcategoryList from './ComponentSubcategoryList';
import ComponentSubcategoryForm from './ComponentSubcategoryForm';
import axios from 'axios';
import safeStorage from '../../utils/safeStorage';

// API URL configuration - uses relative URL in production (nginx proxies to backend)
const API_URL = process.env.REACT_APP_API_URL || 
  (window.location.hostname === 'localhost' && window.location.port === '3002'
    ? 'http://localhost:3000/api'
    : '/api');

const api = axios.create({ baseURL: API_URL });
api.interceptors.request.use(config => {
  const token = safeStorage.getItem('authToken');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});
const categoryApi = axios.create({ baseURL: API_URL });

const ComponentSubcategoryScreen = () => {
  const [subcategories, setSubcategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [editingSubcategory, setEditingSubcategory] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [filters, setFilters] = useState({
    subcategory_name: '',
    subcategory_description: '',
    component_category_id: ''
  });

  const fetchSubcategories = async () => {
    const params = {};
    Object.keys(filters).forEach(key => {
      if (filters[key]) params[key] = filters[key];
    });
    const res = await api.get('/component_subcategories', { params });
    setSubcategories(res.data);
  };

  const fetchCategories = async () => {
    const res = await categoryApi.get('/component_categories');
    setCategories(res.data);
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    fetchSubcategories();
    // eslint-disable-next-line
  }, [filters]);

  const handleCreate = () => {
    setEditingSubcategory(null);
    setShowForm(true);
  };

  const handleEdit = subcat => {
    setEditingSubcategory(subcat);
    setShowForm(true);
  };

  const handleDelete = async id => {
    await api.delete(`/component_subcategories/${id}`);
    fetchSubcategories();
  };

  const handleSave = async formData => {
    if (editingSubcategory) {
      await api.put(`/component_subcategories/${editingSubcategory.component_subcategory_id}`, formData);
    } else {
      await api.post('/component_subcategories', formData);
    }
    fetchSubcategories();
    setShowForm(false);
    setEditingSubcategory(null);
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingSubcategory(null);
  };

  const handleFilterChange = (field, value) => {
    setFilters(f => ({ ...f, [field]: value }));
  };

  return (
    <div>
      <h1>Component Subcategories</h1>
      <button onClick={handleCreate}>Create New Subcategory</button>
      {showForm && (
        <ComponentSubcategoryForm
          subcategory={editingSubcategory}
          categories={categories}
          onSave={handleSave}
          onCancel={handleCancel}
        />
      )}
      <ComponentSubcategoryList
        subcategories={subcategories}
        filters={filters}
        onFilterChange={handleFilterChange}
        onEdit={handleEdit}
        onDelete={handleDelete}
        categories={categories}
      />
    </div>
  );
};

export default ComponentSubcategoryScreen;